export * from './image-quill-toolbar-button.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/image-quill-toolbar-button/index.ts